/**
 * Avisos da camada HTTP para quem cuida da sessão. Existe para o `api.ts` não
 * importar o `authStore` (que já importa o `api`): o interceptor só emite, e o
 * layout decide o que fazer.
 */
type Listener = () => void;

const memberDisabledListeners = new Set<Listener>();

/** A API respondeu `MEMBER_DISABLED`: o dono desativou este membro. */
export function emitMemberDisabled(): void {
  memberDisabledListeners.forEach((listener) => listener());
}

export function onMemberDisabled(listener: Listener): () => void {
  memberDisabledListeners.add(listener);
  return () => {
    memberDisabledListeners.delete(listener);
  };
}
